var table_viewer_default = {
  "viewMode": "BlGwA",
  "editMode": "QUyCD",
  "container": "_1GQw-",
  "cell": "FBOtK"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
